<template>
  <v-card flat>
    <v-card-title>
      <v-btn @click="close()" icon class="mr-2">
        <v-icon>mdi-close</v-icon>
      </v-btn>
      {{ $lang('property-extras.title')}}
    </v-card-title>
    <v-card-text>
      <v-simple-table dense>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">
                {{ $lang("property-extras.fields.name") }}
              </th>
              <th class="text-left" style="width: 40px;">
                {{ $lang("reservation-extras.fields.quantity") }}
              </th>
              <th class="text-left">
                {{ $lang("property-extras.fields.amount") }}
              </th>
              <th class="text-left">
                {{ $lang("property-extras.fields.type") }}
              </th>
              <th class="text-right">
                {{ $lang("main.crud.actions") }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in items" :key="index">
              <td class="text-left">
                {{ item.name }} / {{ item.property.name }}
              </td>
              <td class="text-left">
                <v-text-field
                  v-model="item.quantity"
                  dense
                  hide-details
                  single-line
                />
              </td>
              <td class="text-left">
                {{ $money(item.amount, item.property.currency) }}
              </td>
              <td class="text-left">
                {{ $constText('ConstExtraTypes', item.type) }}
              </td>
              <td class="text-right">
                <v-btn small color="primary" @click="addExtra(item)">
                  <v-icon small class="mr-1">mdi-plus</v-icon>
                  {{ $lang('main.crud.add') }}
                </v-btn>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>

      <v-pagination
        v-if="pagination.total > pagination.perPage"
        v-model="pagination.page"
        :length="pagination.totalPages"
        :total-visible="10"
      />
    </v-card-text>
  </v-card>
</template>

<script>
  import { mapState } from "vuex";

  import {
    GET_PROPERTY_EXTRAS_PAGINATION
  } from "@/store/property-extras/actions";

  export default {
    name: "PropertyExtrasImport",
    props: {
      companyId: {
        type: Number,
        required: true
      },
      form: {
        type: Object,
        default: () => {
          return {};
        }
      }
    },
    data() {
      return {
        filters: {
          order: 'asc',
          sortBy: "name",
          active: true,
        },
        items: [],
      };
    },
    beforeMount() {
      this.getData();
    },
    methods: {
      getData() {
        let reservationIds = [];
        let filters = {};

        if (this.form.bill_details) {
          this.form.bill_details.map(item => {
            if (!item.reservation_id) {
              return;
            }

            reservationIds.push(item.reservation_id);
          })

          reservationIds = [...new Set(reservationIds)];
        }

        if (reservationIds.length) {
          filters = {
            reservation_ids: reservationIds
          };
        } else {
          filters = {
            company_id: this.companyId
          }
        }

        this.items = [],

        this.$store.dispatch(GET_PROPERTY_EXTRAS_PAGINATION, {
          ...filters,
          order: 'asc',
          sortBy: 'name',
          _data: {
            relations: {
              property: {
                selects: [
                  'id',
                  'name',
                  'currency',
                ]
              }
            }
          }
        }).then(response => {
          response.collection.map(item => {
            this.items.push({
              ...item,
              quantity: 1,
            })
          });
        });
      },
      addExtra(item) {
        this.$emit("input", {
          ...item,
          name: `${item.name} x${item.quantity}`, 
          amount: parseFloat(item.amount) * item.quantity,
        });
      },
      close() {
        this.$emit("close");
      }
    },
    computed: {
      ...mapState({
        request: state => state.propertyExtras.getPaginationrequest,
      }),
      pagination() {
        if (!this.request) {
          return {
            page: 1,
            perPage: 15
          };
        }

        if (!this.request.pagination) {
          return {};
        }

        return this.request.pagination;
      },
    }
  }
</script>
